import {Component, h} from "preact";
import {AppPage} from "../_common/components/app-page";
import {connect} from "react-redux";
import {t} from '../_i18n';
import {CF} from "../_common/layout";
import {CompanyCompany} from "../_api";
import {fetchCompany} from "../_rx/jobs/actions";

type Props = {company:CompanyCompany, fetchCompany:Function};

class View extends Component<Props,{}> {

    componentDidMount() {
        this.props.fetchCompany();
    }

    render({ company}:Props) {

        return <CF className="max-width">
            <pre>{JSON.stringify(company,null,'  ')}</pre>
        </CF>;
    }
}

const ConnectedView: any = connect(
    ({company}:any)=>({company}), {fetchCompany})(View as any);

export default () =>
    <AppPage
        name="company-profile"
        title={t('Empresa')}
        subtitle=""
        className="max-width">
        <ConnectedView />

    </AppPage>
;
